import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { MemberService } from './../../rest/api/member.service';

import { AuthService } from './../../services/auth.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit, OnDestroy {
  private subscribeData: Subscription;
  isLoading = true;
  isVerified = false;

  errMessage: any;
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    public stitle: Title,
    public memberService: MemberService,
    private authService: AuthService,
  ) { }

  ngOnInit() {

    this.authService.profileReceived.subscribe(this.profileReceived.bind(this));
    this.authService.profileError.subscribe(this.loginError.bind(this));

    this.subscribeData = this.route.params.subscribe(params => {
      if (!params.id) {
        this.router.navigate(['/']);
      }
      this.memberService.verifyEmail(params.id).subscribe(res => {
        this.authService.profile(res);
      }, err => {
        this.isLoading = false;
        this.errMessage = err.error && err.error.message ? err.error.message : 'Token has expired.';
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 5000);
      });
    });
  }

  profileReceived(res) {
    this.isLoading = false;
    this.isVerified = true;
    setTimeout(() => {
      window.location.href = '/payment';
    }, 5000);
  }

  loginError(error) {
    this.isLoading = false;
    this.errMessage = error.error && error.error.message ? error.error.message : 'Token has expired.';
    this.router.navigate(['/']);
  }

  ngOnDestroy() {
    this.subscribeData.unsubscribe();
  }

}
